import React, { useMemo, useState } from 'react';
import { Button, Card, CardContent } from '@material-ui/core';
import { ReactFlowProvider } from '@xyflow/react';
import I18n from '../../../localization';

import Icon from '../../../utils/icons';
import AirHvacFlowDiagram from './AirHvacFlowDiagram';

const AirHvacDiagramView = ({
  classes,
  airDevices = [],
  hvacs = [],
  canAddHvac,
  hasSecondary,
  isLinkingPending,
  onAddHvac,
  onDeleteHvac,
  onLinkClick,
  handleBack,
  isLinkingDone,
  rescan,
  isWeb,
  fromManageHVACSystem,
  isLinkingPendingForNewlyHvacAdded,
  ...props
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const showEdit = useMemo(
    () => (hasSecondary && !isLinkingPending) && !isLinkingPendingForNewlyHvacAdded,
    [hasSecondary, isLinkingPending,isLinkingPendingForNewlyHvacAdded]
  );

  const renderButtons = () => {
    if (!hasSecondary) {
      return (
        <>
          <Button className={classes.buttonRetry} onClick={handleBack}>{I18n.t('mobile.linkHvacToThermostat.viewInstructions')}</Button>
          <Button className={classes.buttonStyle} onClick={rescan}>{I18n.t('mobile.linkHvacToThermostat.rescan')}</Button>
        </>
      );
    }

    if (isEditing || isLinkingPending || isLinkingPendingForNewlyHvacAdded) {
      return (
        <>
          <Button className={classes.buttonRetry} disabled={!canAddHvac} onClick={onAddHvac}>
            <Icon src="circularPlus" className="circularPlusIcon" /> &nbsp; {I18n.t('mobile.linkHvacToThermostat.addNewHVAC')}
          </Button>
          <Button className={classes.buttonStyle} onClick={() => onLinkClick('linkingForm')}>
            {I18n.t('mobile.linkHvacToThermostat.linkThermostattoHVAC')}
          </Button>
        </>
      );
    }

    return (
      <Button className={classes.buttonStyle} onClick={() => onLinkClick('successPage')}>
        {I18n.t('mobile.linkHvacToThermostat.proceed')}
      </Button>
    );
  };

  const showSecondaryCard=()=>{
    if(fromManageHVACSystem){
      return false
    }
    if(!hasSecondary){
      return true
    }
    return false
  }

  return (
    <>
      <ReactFlowProvider>
        {airDevices.length && hvacs.length ? (
          <div className={classes.grayBgContainer}>
            <div className={classes.connectionContainer}>
              <div className={classes.legendContainer}>
                <span><Icon src="wiredConnection" /> <label>{I18n.t('mobile.AirDeviceProvisioning.wiredConnection')}</label></span>
                <span><Icon src="zWaveConnection" /> <label>{I18n.t('mobile.AirDeviceProvisioning.zWave')}</label></span>
              </div>
              {(!fromManageHVACSystem && showEdit) && (
                isEditing
                  ? <span onClick={() => setIsEditing(false)}><Icon src="plainClose" /></span>
                  : <span className={classes.legendEditBtn} onClick={() => setIsEditing(true)}>{I18n.t('mobile.linkHvacToThermostat.edit')}</span>
              )}
            </div>

            <AirHvacFlowDiagram airDevices={airDevices} hvacs={hvacs} onDeleteHvac={onDeleteHvac} fromManageHVACSystem={fromManageHVACSystem} {...props} />

            {showSecondaryCard() && (
              <Card className={classes.noDeviceCard}>
                <CardContent>
                  <div className={classes.noDeviceIconSection}>
                    <Icon src="smallInfo" /> <span>{I18n.t('mobile.linkHvacToThermostat.noIQAirSecondaryFound')}</span>
                  </div>
                  <span className={classes.smallText}>
                    {I18n.t('mobile.linkHvacToThermostat.pleaseEnsure')}
                  </span>
                </CardContent>
              </Card>
            )}
          </div>
        ) : (
          <div>{I18n.t('mobile.linkHvacToThermostat.noDevicesAvailable')}</div>
        )}
      </ReactFlowProvider>

     {(!fromManageHVACSystem) && <div className={classes.linkButtonContainer}>
        {renderButtons()}
      </div>}
    </>
  );
};

export default React.memo(AirHvacDiagramView);
